import React, { Component } from "react";
import DonorCard from "./DonorCard";
import * as XLSX from "xlsx";
const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const BLOOD_GROUPS = [
  "A+",
  "A-",
  "B+",
  "B-",
  "AB+",
  "AB-",
  "O+",
  "O-",
  "Unknown",
];

const RELATIONS = [
  "Father",
  "Mother",
  "Brother",
  "Sister",
  "Husband",
  "Wife",
  "Son",
  "Daughter",
  "Uncle",
  "Aunt",
  "Cousin",
  "Friend",
  "Other",
];

const GENDERS = ["Male", "Female", "Other"];
const STATUS_OPTIONS = ["approved", "rejected"];

const EMPTY_FORM = {
  id: null,
  fullName: "",
  age: "",
  gender: "",
  bloodGroup: "",
  cnic: "",
  whatsapp: "",
  address: "",
  city: "",
  emergencyName: "",
  emergencyRelation: "",
  emergencyPhone: "",
  password: "",
  confirm_password: "",
};

class DonorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      donors: [],
      loading: true,
      error: null,
      showFormModal: false,
      formMode: "add",
      form: { ...EMPTY_FORM },
      formErrors: {},
      saving: false,
      search: "",
      statusFilter: "all",
      patientSearch: "",
      bloodGroupFilter: "",
      showDonorModal: false,
      selectedDonor: null,
      showCardModal: false,
      cardDonor: null,
      sendingWhatsApp: false,
      showStatusModal: false,
      statusDonor: null,
      selectedStatus: "",
      updatingStatus: false,
      cities: [],
      viewMode: "table",
      selectedRows: [],
      showBulkActions: false,
      showImportModal: false,
      importFile: null,
      importing: false,
      importProgress: { done: 0, total: 0 },
      importResults: [],
      showBulkStatusModal: false,
      bulkSelectedStatus: "",
      bulkUpdating: false,
      bulkProgress: { done: 0, total: 0 },
      bulkResults: [],
      showDeleteModal: false,
      deleteDonorData: null,
      deleting: false,
    };
  }

  componentDidMount() {
    if (
      navigator.share === undefined &&
      window.location.protocol === "http:" &&
      window.location.hostname !== "localhost"
    ) {
      window.location.replace(window.location.href.replace(/^http:/, "https:"));
    }
    this.fetchDonors();
    fetch(`${API_BASE}/api/cities`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          this.setState({ cities: data.data });
        }
      })
      .catch((err) => console.error("Failed to load cities:", err));
  }

  fetchDonors = () => {
    this.setState({ loading: true, error: null });
    fetch(`${API_BASE}/api/donors`)
      .then((res) => {
        if (!res.ok)
          throw new Error(`Failed to fetch donors (HTTP ${res.status}).`);
        return res.json();
      })
      .then((data) => {
        this.setState({
          donors: data.data || data.donors || [],
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ error: err.message, loading: false });
      });
  };

  parseExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          // defval: "" avoids undefined for blank cells
          const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });
          resolve(rows);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(new Error("Failed to read file."));
      reader.readAsArrayBuffer(file);
    });
  };

  normalizeImportRow = (row) => {
    const map = {
      fullname: "fullName",
      "full name": "fullName",
      name: "fullName",
      age: "age",
      gender: "gender",
      bloodgroup: "bloodGroup",
      "blood group": "bloodGroup",
      cnic: "cnic",
      whatsapp: "whatsapp",
      address: "address",
      city: "city",
      emergencyname: "emergencyName",
      "emergency name": "emergencyName",
      "emergency contact": "emergencyName",
      emergencyrelation: "emergencyRelation",
      "emergency relation": "emergencyRelation",
      relation: "emergencyRelation",
      emergencyphone: "emergencyPhone",
      "emergency phone": "emergencyPhone",
    };

    const normalized = {};
    Object.keys(row).forEach((key) => {
      const cleanKey = key.trim().toLowerCase();
      const mappedKey = map[cleanKey];
      if (mappedKey) {
        normalized[mappedKey] = String(row[key] ?? "").trim();
      }
    });
    return normalized;
  };

  resolveCityId = (cityValue) => {
    if (!cityValue) return "";
    if (/^\d+$/.test(cityValue)) return cityValue; // already an id
    const match = this.state.cities.find(
      (c) => c.name.trim().toLowerCase() === cityValue.trim().toLowerCase(),
    );
    return match ? String(match.id) : "";
  };
  handleImportFileChange = (e) => {
    this.setState({ importFile: e.target.files[0] || null, importResults: [] });
  };
 
  submitImport = async () => {
    const { importFile } = this.state;
    if (!importFile) return;

    this.setState({ importing: true, importResults: [] });

    let rawRows;
    try {
      rawRows = await this.parseExcelFile(importFile);
    } catch (err) {
      this.setState({
        importing: false,
        importResults: [
          {
            row: "-",
            name: "-",
            status: "error",
            message: "Could not read the file: " + err.message,
          },
        ],
      });
      return;
    }

    if (!rawRows.length) {
      this.setState({
        importing: false,
        importResults: [
          {
            row: "-",
            name: "-",
            status: "error",
            message: "The file has no data rows.",
          },
        ],
      });
      return;
    }

    this.setState({ importProgress: { done: 0, total: rawRows.length } });

    const results = [];

    // Sequential loop so we don't hammer the backend and so donor IDs
    // generate cleanly one at a time (matches single Add Donor behavior)
    for (let i = 0; i < rawRows.length; i++) {
      const lineNo = i + 2; // +2 = header row + 1-index
      const row = this.normalizeImportRow(rawRows[i]);
      const rowName = row.fullName || "(blank)";

      // Skip fully blank rows
      if (!row.fullName && !row.cnic && !row.whatsapp) {
        results.push({
          row: lineNo,
          name: rowName,
          status: "error",
          message: "Empty row, skipped.",
        });
        this.setState((prev) => ({
          importProgress: { ...prev.importProgress, done: i + 1 },
        }));
        continue;
      }

      const fd = new FormData();
      fd.append("fullName", row.fullName || "");
      fd.append("age", row.age || "");
      fd.append("gender", row.gender || "");
      fd.append("bloodGroup", row.bloodGroup || "");
      fd.append("cnic", row.cnic || "");
      fd.append("whatsapp", row.whatsapp || "");
      fd.append("address", row.address || "");
      fd.append("city", this.resolveCityId(row.city));
      fd.append("emergencyName", row.emergencyName || "");
      fd.append("emergencyRelation", row.emergencyRelation || "");
      fd.append("emergencyPhone", row.emergencyPhone || "");

      try {
        const res = await fetch(`${API_BASE}/api/donors/register`, {
          method: "POST",
          body: fd,
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        const data = await res.json();

        if (res.ok && data.status) {
          results.push({
            row: lineNo,
            name: rowName,
            status: "success",
            message: `Registered as ${data.data.donor_id}`,
          });
        } else {
          const errMsg = data.errors
            ? Object.values(data.errors).join(", ")
            : data.message || "Failed.";
          results.push({
            row: lineNo,
            name: rowName,
            status: "error",
            message: errMsg,
          });
        }
      } catch (err) {
        results.push({
          row: lineNo,
          name: rowName,
          status: "error",
          message: "Network error: " + err.message,
        });
      }

      this.setState((prev) => ({
        importProgress: { ...prev.importProgress, done: i + 1 },
      }));
    }

    this.setState({ importing: false, importResults: results });
    this.fetchDonors();
  };
  openImportModal = () => {
    this.setState({
      showImportModal: true,
      importFile: null,
      importResults: [],
      importProgress: { done: 0, total: 0 },
    });
  };

  closeImportModal = () => {
    this.setState({
      showImportModal: false,
      importFile: null,
      importResults: [],
      importing: false,
    });
  };

  renderImportModal() {
    const {
      showImportModal,
      importFile,
      importing,
      importProgress,
      importResults,
    } = this.state;
    if (!showImportModal) return null;

    const successCount = importResults.filter(
      (r) => r.status === "success",
    ).length;
    const errorCount = importResults.filter((r) => r.status === "error").length;

    return (
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title">Import Donors from Excel</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={this.closeImportModal}
                disabled={importing}
              />
            </div>
            <div className="modal-body">
              <p className="text-muted small mb-2">
                Columns (any order, case-insensitive):{" "}
                <strong>
                  Full Name, Age, Gender, Blood Group, City (all required),
                  CNIC, WhatsApp, Address, Emergency Name, Emergency Relation,
                  Emergency Phone (optional)
                </strong>
                . Each row goes through the same validation as adding a donor
                manually.
              </p>
              <input
                type="file"
                accept=".xlsx,.xls,.csv"
                className="form-control"
                onChange={this.handleImportFileChange}
                disabled={importing}
              />

              {importing && (
                <div className="mt-3">
                  <div className="progress" style={{ height: "20px" }}>
                    <div
                      className="progress-bar bg-danger"
                      style={{
                        width: `${(importProgress.done / importProgress.total) * 100}%`,
                      }}
                    >
                      {importProgress.done}/{importProgress.total}
                    </div>
                  </div>
                  <p className="text-muted small mt-2 mb-0">
                    Importing row by row, please don't close this window...
                  </p>
                </div>
              )}

              {!importing && importResults.length > 0 && (
                <>
                  <div className="alert alert-secondary mt-3 mb-2">
                    {successCount} imported successfully, {errorCount} failed.
                  </div>
                  <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <table className="table table-sm">
                      <thead>
                        <tr>
                          <th>Row</th>
                          <th>Name</th>
                          <th>Result</th>
                        </tr>
                      </thead>
                      <tbody>
                        {importResults.map((r, i) => (
                          <tr
                            key={i}
                            className={
                              r.status === "error"
                                ? "table-danger"
                                : "table-success"
                            }
                          >
                            <td>{r.row}</td>
                            <td>{r.name}</td>
                            <td>{r.message}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={this.closeImportModal}
                disabled={importing}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={this.submitImport}
                disabled={!importFile || importing}
              >
                {importing ? "Importing..." : "Upload & Import"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  filterDonors = () => {
    const { donors, search, statusFilter, patientSearch, bloodGroupFilter } =
      this.state;
    return donors.filter((d) => {
      const matchesSearch =
        !search ||
        (d.full_name || "").toLowerCase().includes(search.toLowerCase()) ||
        (d.cnic || "").includes(search);
      const matchesStatus =
        statusFilter === "all" ||
        (d.status || "").toLowerCase() === statusFilter.toLowerCase();
      const matchesPatient =
        !patientSearch ||
        (d.full_name || "")
          .toLowerCase()
          .includes(patientSearch.toLowerCase()) ||
        (d.donor_id || "").toLowerCase().includes(patientSearch.toLowerCase());
      const matchesBloodGroup =
        !bloodGroupFilter || d.blood_group === bloodGroupFilter;
      return (
        matchesSearch && matchesStatus && matchesPatient && matchesBloodGroup
      );
    });
  };

  getBloodGroupColor = (group) => {
    const colors = {
      "A+": "danger",
      "A-": "danger",
      "B+": "primary",
      "B-": "primary",
      "AB+": "success",
      "AB-": "success",
      "O+": "warning",
      "O-": "warning",
    };
    return colors[group] || "secondary";
  };

  initials = (name) =>
    (name?.trim() || "?")
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((p) => p[0].toUpperCase())
      .join("");

  // Keep all your existing methods
  openEditFromTable = (donor) => {
    this.setState({
      formMode: "edit",
      formErrors: {},
      form: {
        id: donor.id,
        fullName: donor.full_name || "",
        age: donor.age || "",
        gender: donor.gender || "",
        bloodGroup: donor.blood_group || "",
        cnic: donor.cnic || "",
        whatsapp: donor.whatsapp || "",
        address: donor.address || "",
        city: donor.city || "",
        emergencyName: donor.emergency_name || "",
        emergencyRelation: donor.emergency_relation || "",
        emergencyPhone: donor.emergency_phone || "",
        password: "",
        confirm_password: "",
      },
      showFormModal: true,
    });
  };

 
  openBulkStatusModal = () => {
    this.setState({
      showBulkStatusModal: true,
      bulkSelectedStatus: "approved",
      bulkResults: [],
    });
  };

  closeBulkStatusModal = () => {
    this.setState({
      showBulkStatusModal: false,
      bulkSelectedStatus: "",
      bulkResults: [],
      bulkUpdating: false,
    });
  };

  handleBulkStatusChange = (e) => {
    this.setState({ bulkSelectedStatus: e.target.value });
  };

  submitBulkStatusUpdate = async () => {
    const { selectedRows, bulkSelectedStatus, donors } = this.state;
    if (!selectedRows.length || !bulkSelectedStatus) return;

    this.setState({
      bulkUpdating: true,
      bulkResults: [],
      bulkProgress: { done: 0, total: selectedRows.length },
    });

    const results = [];

    for (let i = 0; i < selectedRows.length; i++) {
      const id = selectedRows[i];
      const donor = donors.find((d) => d.id === id);
      const name = donor?.full_name || `Donor #${id}`;

      try {
        const res = await fetch(`${API_BASE}/api/donors/${id}/status`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ status: bulkSelectedStatus }),
        });
        const data = await res.json();

        if (res.ok && data.status) {
          results.push({
            id,
            name,
            status: "success",
            message: `Set to ${bulkSelectedStatus}`,
          });
        } else {
          results.push({
            id,
            name,
            status: "error",
            message: data.message || "Failed.",
          });
        }
      } catch (err) {
        results.push({
          id,
          name,
          status: "error",
          message: "Network error: " + err.message,
        });
      }

      this.setState((prev) => ({
        bulkProgress: { ...prev.bulkProgress, done: i + 1 },
      }));
    }

    this.setState({
      bulkUpdating: false,
      bulkResults: results,
      selectedRows: [],
      showBulkActions: false,
    });
    this.fetchDonors();
  };

  toggleRowSelection = (donorId) => {
    this.setState((prev) => {
      const selectedRows = prev.selectedRows.includes(donorId)
        ? prev.selectedRows.filter((id) => id !== donorId)
        : [...prev.selectedRows, donorId];
      return {
        selectedRows,
        showBulkActions: selectedRows.length > 0,
      };
    });
  };

  selectAllRows = () => {
    const filtered = this.filterDonors();
    const allIds = filtered.map((d) => d.id);
    const { selectedRows } = this.state;
    const allSelected = allIds.every((id) => selectedRows.includes(id));
    this.setState({
      selectedRows: allSelected ? [] : allIds,
      showBulkActions: !allSelected && allIds.length > 0,
    });
  };

  openStatusModal = (donor) => {
    this.setState({
      showStatusModal: true,
      statusDonor: donor,
      selectedStatus: "approved",
      updatingStatus: false,
    });
  };

  closeStatusModal = () => {
    this.setState({
      showStatusModal: false,
      statusDonor: null,
      selectedStatus: "",
      updatingStatus: false,
    });
  };

  openDonorDetailsModal = (donor) => {
    this.setState({
      showDonorModal: true,
      selectedDonor: donor,
    });
  };

   handleStatusChange = (e) => {
    this.setState({ selectedStatus: e.target.value });
  };

  submitStatusUpdate = () => {
    const { statusDonor, selectedStatus } = this.state;
    if (!statusDonor || !selectedStatus) {
      return;
    }
    this.setState({ updatingStatus: true });
    fetch(`${API_BASE}/api/donors/${statusDonor.id}/status`, {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ status: selectedStatus }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (data.status === true) {
          const updatedDonor = { ...statusDonor, status: selectedStatus };
          this.setState((prev) => ({
            donors: prev.donors.map((d) =>
              d.id === statusDonor.id ? updatedDonor : d,
            ),
          }));
          this.closeStatusModal();
        } else {
          this.setState({
            error: data.message || "Failed to update status.",
            updatingStatus: false,
          });
        }
      })
      .catch((err) => {
        console.error("Status update error:", err);
        this.setState({
          error: "Failed to update status. Please try again.",
          updatingStatus: false,
        });
      });
  };

  renderStatusModal() {
    const { showStatusModal, statusDonor, selectedStatus, updatingStatus } =
      this.state;
    if (!showStatusModal || !statusDonor) return null;

    return (
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title">Change Donor Status</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={this.closeStatusModal}
                disabled={updatingStatus}
              />
            </div>
            <div className="modal-body">
              <div className="mb-4">
                <p className="mb-1">
                  <strong>Donor:</strong> {statusDonor.full_name}
                </p>
                <p className="mb-1">
                  <strong>Donor ID:</strong> {statusDonor.donor_id}
                </p>
                <p className="mb-3">
                  <strong>Current Status:</strong>{" "}
                  {this.renderStatusBadge(statusDonor.status)}
                </p>
              </div>
              <div className="mb-3">
                <label className="form-label fw-semibold">New Status</label>
                <select
                  className="form-select"
                  value={selectedStatus}
                  onChange={this.handleStatusChange}
                  disabled={updatingStatus}
                >
                  {STATUS_OPTIONS.map((status) => (
                    <option key={status} value={status}>
                      {status.charAt(0).toUpperCase() + status.slice(1)}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={this.closeStatusModal}
                disabled={updatingStatus}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={this.submitStatusUpdate}
                disabled={
                  updatingStatus || selectedStatus === statusDonor.status
                }
              >
                {updatingStatus ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Updating...
                  </>
                ) : (
                  "Update Status"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderBulkStatusModal() {
    const {
      showBulkStatusModal,
      selectedRows,
      bulkSelectedStatus,
      bulkUpdating,
      bulkProgress,
      bulkResults,
      donors,
    } = this.state;
    if (!showBulkStatusModal) return null;

    const selectedDonors = donors.filter((d) => selectedRows.includes(d.id));
    const successCount = bulkResults.filter(
      (r) => r.status === "success",
    ).length;
    const errorCount = bulkResults.filter((r) => r.status === "error").length;

    return (
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title">
                Change Status for {selectedRows.length} Donor(s)
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={this.closeBulkStatusModal}
                disabled={bulkUpdating}
              />
            </div>
            <div className="modal-body">
              {!bulkUpdating && bulkResults.length === 0 && (
                <>
                  <div
                    className="mb-3"
                    style={{ maxHeight: "180px", overflowY: "auto" }}
                  >
                    <ul className="list-group list-group-flush">
                      {selectedDonors.map((d) => (
                        <li
                          key={d.id}
                          className="list-group-item d-flex justify-content-between py-1 px-0"
                        >
                          <span>{d.full_name}</span>
                          {this.renderStatusBadge(d.status)}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      New Status for All Selected
                    </label>
                    <select
                      className="form-select"
                      value={bulkSelectedStatus}
                      onChange={this.handleBulkStatusChange}
                    >
                      {STATUS_OPTIONS.map((status) => (
                        <option key={status} value={status}>
                          {status.charAt(0).toUpperCase() + status.slice(1)}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}

              {bulkUpdating && (
                <div>
                  <div className="progress" style={{ height: "20px" }}>
                    <div
                      className="progress-bar bg-danger"
                      style={{
                        width: `${(bulkProgress.done / bulkProgress.total) * 100}%`,
                      }}
                    >
                      {bulkProgress.done}/{bulkProgress.total}
                    </div>
                  </div>
                  <p className="text-muted small mt-2 mb-0">
                    Updating donor by donor, please wait...
                  </p>
                </div>
              )}

              {!bulkUpdating && bulkResults.length > 0 && (
                <>
                  <div className="alert alert-secondary mb-2">
                    {successCount} updated successfully, {errorCount} failed.
                  </div>
                  <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                    <table className="table table-sm">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Result</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bulkResults.map((r, i) => (
                          <tr
                            key={i}
                            className={
                              r.status === "error"
                                ? "table-danger"
                                : "table-success"
                            }
                          >
                            <td>{r.name}</td>
                            <td>{r.message}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={this.closeBulkStatusModal}
                disabled={bulkUpdating}
              >
                Close
              </button>
              {bulkResults.length === 0 && (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={this.submitBulkStatusUpdate}
                  disabled={bulkUpdating || !selectedRows.length}
                >
                  {bulkUpdating ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Updating...
                    </>
                  ) : (
                    `Update ${selectedRows.length} Donor(s)`
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  closeDonorDetailsModal = () => {
    this.setState({
      showDonorModal: false,
      selectedDonor: null,
    });
  };

  renderDonorDetailsModal() {
    const { showDonorModal, selectedDonor } = this.state;
    if (!showDonorModal || !selectedDonor) return null;

    const displayAge = selectedDonor.age || "-";

    return (
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title">
                Donor Details — {selectedDonor.full_name}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={this.closeDonorDetailsModal}
              />
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>Donor ID:</strong> {selectedDonor.donor_id || "N/A"}
                  </p>
                  <p>
                    <strong>Full Name:</strong> {selectedDonor.full_name}
                  </p>
                  <p>
                    <strong>Age:</strong> {displayAge}
                    {displayAge !== "-" ? " years" : ""}
                  </p>
                  <p>
                    <strong>Gender:</strong> {selectedDonor.gender}
                  </p>
                  <p>
                    <strong>Blood Group:</strong>{" "}
                    <span
                      className={`badge bg-${this.getBloodGroupColor(selectedDonor.blood_group)}`}
                    >
                      {selectedDonor.blood_group}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <strong>CNIC:</strong> {selectedDonor.cnic || "-"}
                  </p>
                  <p>
                    <strong>WhatsApp:</strong> {selectedDonor.whatsapp || "-"}
                  </p>
                  <p>
                    <strong>Address:</strong> {selectedDonor.address || "-"}
                  </p>
                  <p>
                    <strong>City:</strong> {selectedDonor.city_name || "-"}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    {this.renderStatusBadge(selectedDonor.status)}
                  </p>
                  <p>
                    <strong>Emergency Contact:</strong>{" "}
                    {selectedDonor.emergency_name || "-"} (
                    {selectedDonor.emergency_relation || "-"}) -{" "}
                    {selectedDonor.emergency_phone || "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  closeFormModal = () => {
    this.setState({
      showFormModal: false,
      form: { ...EMPTY_FORM },
      formErrors: {},
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    const formatters = {
      age: (v) => {
        const digits = v.replace(/\D/g, "").slice(0, 3);
        return { value: digits, extra: {}, error: "" };
      },
      cnic: (v) => {
        const digits = v.replace(/\D/g, "").slice(0, 13);
        const formatted =
          digits.length <= 5
            ? digits
            : digits.length <= 12
              ? `${digits.slice(0, 5)}-${digits.slice(5)}`
              : `${digits.slice(0, 5)}-${digits.slice(5, 12)}-${digits.slice(12)}`;
        return { value: formatted, extra: {}, error: "" };
      },
      whatsapp: (v) => {
        const digits = v.replace(/\D/g, "").slice(0, 11);
        const formatted =
          digits.length <= 4
            ? digits
            : `${digits.slice(0, 4)}-${digits.slice(4)}`;
        return { value: formatted, extra: {}, error: "" };
      },
      emergencyPhone: (v) => {
        const digits = v.replace(/\D/g, "").slice(0, 11);
        const formatted =
          digits.length <= 4
            ? digits
            : `${digits.slice(0, 4)}-${digits.slice(4)}`;
        return { value: formatted, extra: {}, error: "" };
      },
    };

    if (formatters[name]) {
      const { value: formattedValue, extra, error } = formatters[name](value);
      this.setState((prev) => ({
        form: { ...prev.form, [name]: formattedValue, ...extra },
        formErrors: { ...prev.formErrors, [name]: error },
      }));
      return;
    }

    this.setState((prev) => ({
      form: { ...prev.form, [name]: value },
      formErrors: { ...prev.formErrors, [name]: "" },
    }));
  };

  validateForm = () => {
    const { form } = this.state;
    const errors = {};

    // ── Mandatory fields ─────────────────────────────
    if (!form.fullName.trim()) errors.fullName = "Full name is required.";
    else if (/\d/.test(form.fullName))
      errors.fullName = "Name must not contain numbers.";

    if (!String(form.age).trim()) {
      errors.age = "Age is required.";
    } else {
      const ageNum = parseInt(form.age, 10);
      if (isNaN(ageNum) || ageNum < 15 || ageNum > 65) {
        errors.age = "Age must be between 15 and 65.";
      }
    }

    if (!form.gender) errors.gender = "Select gender.";
    if (!form.bloodGroup) errors.bloodGroup = "Select blood group.";
    if (!form.city) errors.city = "Select a city.";

    // ── Optional fields — only validated if the user filled them in ──

    if (form.whatsapp && form.whatsapp.trim()) {
      const waDigits = form.whatsapp.replace(/\D/g, "");
      if (waDigits.length !== 11)
        errors.whatsapp = "Enter a valid number (e.g. 0313-5495655).";
    }

    if (form.emergencyName && /\d/.test(form.emergencyName))
      errors.emergencyName = "Name must not contain numbers.";

    if (form.emergencyPhone && form.emergencyPhone.trim()) {
      const emergDigits = form.emergencyPhone.replace(/\D/g, "");
      if (emergDigits.length !== 11)
        errors.emergencyPhone = "Enter a valid number (e.g. 0300-1234567).";
    }

    this.setState({ formErrors: errors });
    return Object.keys(errors).length === 0;
  };

  renderFormModal() {
    const { showFormModal, form, formErrors, saving, formMode, cities } =
      this.state;
    if (!showFormModal) return null;

    return (
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title">
                {formMode === "edit" ? "Edit Donor" : "Add Donor"}{" "}
                <strong>{form.fullName}</strong>
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={this.closeFormModal}
              />
            </div>
            <div className="modal-body">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-body">
                  {formErrors.general && (
                    <div className="alert alert-danger">
                      {formErrors.general}
                    </div>
                  )}
                  <div className="row g-3">
                    {this.renderField(
                      "Full Name *",
                      "fullName",
                      form.fullName,
                      formErrors.fullName,
                    )}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Age *</label>
                      <input
                        type="text"
                        inputMode="numeric"
                        name="age"
                        maxLength={3}
                        placeholder="e.g. 25"
                        className={`form-control ${formErrors.age ? "is-invalid" : ""}`}
                        value={form.age}
                        onChange={this.handleInputChange}
                      />
                      {formErrors.age && (
                        <div className="invalid-feedback">{formErrors.age}</div>
                      )}
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Gender *</label>
                      <select
                        name="gender"
                        className={`form-select ${formErrors.gender ? "is-invalid" : ""}`}
                        value={form.gender}
                        onChange={this.handleInputChange}
                      >
                        <option value="">Select</option>
                        {GENDERS.map((g) => (
                          <option key={g} value={g}>
                            {g}
                          </option>
                        ))}
                      </select>
                      {formErrors.gender && (
                        <div className="invalid-feedback">
                          {formErrors.gender}
                        </div>
                      )}
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Blood Group *
                      </label>
                      <select
                        name="bloodGroup"
                        className={`form-select ${formErrors.bloodGroup ? "is-invalid" : ""}`}
                        value={form.bloodGroup}
                        onChange={this.handleInputChange}
                      >
                        <option value="">Select</option>
                        {BLOOD_GROUPS.map((b) => (
                          <option key={b} value={b}>
                            {b}
                          </option>
                        ))}
                      </select>
                      {formErrors.bloodGroup && (
                        <div className="invalid-feedback">
                          {formErrors.bloodGroup}
                        </div>
                      )}
                    </div>

                    {this.renderField(
                      "CNIC",
                      "cnic",
                      form.cnic,
                      formErrors.cnic,
                      "text",
                      { maxLength: 15, placeholder: "XXXXX-XXXXXXX-X" },
                    )}
                    {this.renderField(
                      "WhatsApp",
                      "whatsapp",
                      form.whatsapp,
                      formErrors.whatsapp,
                      "text",
                      { maxLength: 12, placeholder: "XXXX-XXXXXXX" },
                    )}
                    {this.renderField(
                      "Address",
                      "address",
                      form.address,
                      formErrors.address,
                      "text",
                      {},
                      "col-12",
                    )}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">City *</label>
                      <select
                        name="city"
                        value={String(form.city)}
                        onChange={this.handleInputChange}
                        className={`form-select ${formErrors.city ? "is-invalid" : ""}`}
                      >
                        <option value="">Select City</option>
                        {cities.map((city) => (
                          <option key={city.id} value={String(city.id)}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                      {formErrors.city && (
                        <div className="invalid-feedback">
                          {formErrors.city}
                        </div>
                      )}
                    </div>

                    {this.renderField(
                      "Emergency Contact Name",
                      "emergencyName",
                      form.emergencyName,
                      formErrors.emergencyName,
                    )}

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Emergency Relation
                      </label>
                      <select
                        name="emergencyRelation"
                        className={`form-select ${formErrors.emergencyRelation ? "is-invalid" : ""}`}
                        value={form.emergencyRelation}
                        onChange={this.handleInputChange}
                      >
                        <option value="">Select Relationship</option>
                        {RELATIONS.map((relation) => (
                          <option key={relation} value={relation}>
                            {relation}
                          </option>
                        ))}
                      </select>
                      {formErrors.emergencyRelation && (
                        <div className="invalid-feedback">
                          {formErrors.emergencyRelation}
                        </div>
                      )}
                    </div>

                    {this.renderField(
                      "Emergency Phone",
                      "emergencyPhone",
                      form.emergencyPhone,
                      formErrors.emergencyPhone,
                      "text",
                      { maxLength: 12, placeholder: "XXXX-XXXXXXX" },
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={this.closeFormModal}
                    disabled={saving}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-danger"
                    disabled={saving}
                  >
                    {saving
                      ? "Saving..."
                      : formMode === "edit"
                        ? "Update Donor"
                        : "Add Donor"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.validateForm()) return;
    this.setState({ saving: true });
    const { formMode, form } = this.state;
    const fd = new FormData();
    Object.keys(form).forEach((key) => {
      if (key === "id") return;
      if (form[key] !== null && form[key] !== undefined)
        fd.append(key, form[key]);
    });

    const url =
      formMode === "add" ? `${API_BASE}/api/donors/register` : `${API_BASE}/api/donors/${form.id}`;
    fetch(url, {
      method: "POST",
      body: fd,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        this.setState({ saving: false });
        if (!ok || data.status === false) {
          this.setState({
            formErrors: data.errors || {
              general: data.message || "Request failed.",
            },
          });
          return;
        }
        this.closeFormModal();
        this.fetchDonors();
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.setState({
          saving: false,
          formErrors: {
            general: "Something went wrong. Check your connection.",
          },
        });
      });
  };

  openCardModal = (donor) => {
    this.setState({ showCardModal: true, cardDonor: donor });
  };

  closeCardModal = () => {
    this.setState({ showCardModal: false, cardDonor: null });
  };

  renderCardModal() {
    const { showCardModal, cardDonor, sendingWhatsApp } = this.state;
    if (!showCardModal || !cardDonor) return null;

    const { issueDate, validity, age } = this.computeCardFields(cardDonor);
    const photoUrl = cardDonor.photo ? `/${cardDonor.photo}` : null;

    return (
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header bg-dark text-white">
              <h5 className="modal-title">Donor Approved — Life Saver Card</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={this.closeCardModal}
              />
            </div>
            <div className="modal-body">
              <DonorCard
                fullName={cardDonor.full_name}
                donorId={cardDonor.donor_id}
                age={age}
                bloodGroup={cardDonor.blood_group}
                whatsapp={cardDonor.whatsapp}
                validity={validity}
                issueDate={issueDate}
                photoPreview={photoUrl}
              />
              <div className="d-flex gap-3 mt-4 justify-content-center">
                <button
                  className="btn btn-danger px-4"
                  onClick={this.downloadCardImage}
                >
                  <i className="bi bi-download me-1"></i> Download Card
                </button>
                <button
                  className="btn btn-success px-4"
                  onClick={this.sendCardAsImage}
                  disabled={sendingWhatsApp}
                >
                  {sendingWhatsApp ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Opening...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-whatsapp me-1"></i> Send to WhatsApp
                    </>
                  )}
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={this.closeCardModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  computeCardFields = (donor) => {
    const issueDateObj = new Date();
    const issueDate = issueDateObj.toLocaleDateString("en-GB");
    const validityDateObj = new Date(issueDateObj);
    validityDateObj.setFullYear(validityDateObj.getFullYear() + 1);
    const validity = validityDateObj.toLocaleDateString("en-GB");
    const age = donor.age || "N/A";
    return { issueDate, validity, age };
  };

  downloadCardImage = () => {
    const { cardDonor } = this.state;
    const cardElement = document.querySelector(".donor-card");
    if (!cardElement || !cardDonor) return;

    import("html2canvas").then((html2canvas) => {
      html2canvas
        .default(cardElement, {
          scale: 3,
          backgroundColor: "#ffffff",
          useCORS: true,
          logging: false,
          width: cardElement.offsetWidth,
          height: cardElement.offsetHeight,
        })
        .then((canvas) => {
          const link = document.createElement("a");
          link.download = `donor-card-${cardDonor.donor_id || cardDonor.id}.png`;
          link.href = canvas.toDataURL("image/png");
          link.click();
        })
        .catch((err) => console.error("Error generating card download:", err));
    });
  };

  sendCardAsImage = async () => {
    const { cardDonor } = this.state;
    const cardElement = document.querySelector(".donor-card");
    if (!cardElement || !cardDonor) return;

    this.setState({ sendingWhatsApp: true, error: null, message: null });

    try {
      const html2canvas = await import("html2canvas");
      const canvas = await html2canvas.default(cardElement, {
        scale: 3,
        backgroundColor: "#ffffff",
        useCORS: true,
        logging: false,
      });

      const donorId = cardDonor.donor_id || cardDonor.id;
      const title =
        cardDonor.gender === "Female"
          ? "Mrs."
          : cardDonor.gender === "Male"
            ? "Mr."
            : "";
      const namePart = title
        ? `${title} ${cardDonor.full_name}`
        : cardDonor.full_name;
      const phone = this.normalizeWhatsApp(cardDonor.whatsapp);

      const imageData = canvas.toDataURL("image/png");

      const saveResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/donors/${cardDonor.id}/save-card-image`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ image: imageData }),
        },
      );

      const saveData = await saveResponse.json();
      if (!saveData.status)
        throw new Error(saveData.message || "Failed to save card image");

      const imageUrl = saveData.url;
      const fileName = imageUrl.split("/").pop();
      const donorCode = fileName.replace(/\.png$/i, "");
      const downloadUrl = `${process.env.REACT_APP_API_BASE_URL}/donorcard/view/${donorCode}?download=1`;

      const registrationDate = cardDonor.created_at
        ? new Date(cardDonor.created_at).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
        : new Date().toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });

      const messageText = `Dear ${namePart},

We are pleased to inform you that you have been registered as a blood donor with AWT Blood Bank on ${registrationDate}. Your blood group is ${cardDonor.blood_group}.

Your Life Saver Card is now ready. Please find the download link below:

${downloadUrl}

Donor ID: ${donorId}

Your generous contribution can help save precious lives. Thank you for being a part of this life-saving mission. ❤️

With sincere thanks,
AWT Blood Bank`;

      const encodedMessage = encodeURIComponent(messageText);
      window.open(`https://wa.me/${phone}?text=${encodedMessage}`, "_blank");

      this.setState({
        message: "✅ Opening WhatsApp with your card!",
        sendingWhatsApp: false,
      });
      setTimeout(() => this.closeCardModal(), 3000);
    } catch (error) {
      console.error("Error sending card:", error);
      this.setState({
        error: "Failed to send card. Please try downloading instead.",
        sendingWhatsApp: false,
      });
    }
  };

  normalizeWhatsApp = (number) => {
    let digits = (number || "").replace(/\D/g, "");
    if (digits.startsWith("0")) digits = digits.slice(1);
    if (!digits.startsWith("92")) digits = "92" + digits;
    return digits;
  };

  renderEligibilityBadge(donor) {
    if (donor.eligibility_status === "not_available") {
      const formatted = donor.eligible_from
        ? new Date(donor.eligible_from).toLocaleDateString("en-GB", { day: "2-digit", month: "short" })
        : null;
      return (
        <span className="badge bg-danger-subtle text-danger-emphasis">
          Not Available{formatted ? ` (till ${formatted})` : ""}
        </span>
      );
    }
    return (
      <span className="badge bg-success-subtle text-success-emphasis">
        Available
      </span>
    );
  }
 
  renderStatusBadge(status) {
    const config = {
      approved: { color: "success", icon: "bi-check-circle" },
      pending: { color: "warning", icon: "bi-clock" },
      rejected: { color: "danger", icon: "bi-x-circle" },
    };
    const { color, icon } = config[status] || config.pending;

    return (
      <span
        className={`badge bg-${color}-subtle text-${color}-emphasis text-capitalize px-3 py-2`}
      >
        <i className={`bi ${icon} me-1`}></i>
        {status}
      </span>
    );
  }

  renderDonorsTable(donors) {
    const { selectedRows } = this.state;

    const allSelected =
      donors.length > 0 && donors.every((d) => selectedRows.includes(d.id));
    const someSelected = donors.some((d) => selectedRows.includes(d.id));

    return (
      <table className="table table-hover align-middle">
        <thead className="table-light text-center">
          <tr>
            <th style={{ minWidth: "40px" }}>
              <input
                type="checkbox"
                className="form-check-input"
                checked={allSelected}
                ref={(el) => {
                  if (el) el.indeterminate = someSelected && !allSelected;
                }}
                onChange={this.selectAllRows}
              />
            </th>

            <th style={{ minWidth: "80px" }}>Donor ID</th>
            <th style={{ minWidth: "130px" }}>Donor Name</th>
            <th style={{ minWidth: "80px" }}>Blood Group</th>
            <th style={{ minWidth: "60px" }}>Age</th>
            <th style={{ minWidth: "80px" }}>Gender</th>
            <th style={{ minWidth: "90px" }}>City</th>
            <th style={{ minWidth: "90px" }}>Status</th>
            <th style={{ minWidth: "110px" }}>Eligibility</th>
            <th style={{ minWidth: "120px" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {donors.map((donor) => {
            const isSelected = selectedRows.includes(donor.id);
            return (
              <tr key={donor.id} className={isSelected ? "table-active" : ""}>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isSelected}
                    onChange={() => this.toggleRowSelection(donor.id)}
                  />
                </td>
                <td className="text-nowrap">
                  <button
                    type="button"
                    className="btn btn-link p-0 text-decoration-none fw-semibold text-danger"
                    onClick={() => this.openDonorDetailsModal(donor)}
                  >
                    {donor.donor_id}
                  </button>
                </td>
                <td className="text-nowrap">{donor.full_name}</td>
                <td>
                  <span
                    className={`badge bg-${this.getBloodGroupColor(donor.blood_group)}`}
                  >
                    {donor.blood_group}
                  </span>
                </td>
                <td className="text-nowrap">{donor.age} years</td>
                <td>{donor.gender}</td>
                <td className="text-nowrap">{donor.city_name || "N/A"}</td>
                <td>{this.renderStatusBadge(donor.status)}</td>
                <td>{this.renderEligibilityBadge(donor)}</td>
                <td className="text-nowrap">{this.renderActions(donor)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  deleteDonor = (donor) => {
    if (
      !window.confirm(
        `Are you sure you want to delete donor "${donor.full_name}" (${donor.donor_id})? This action cannot be undone.`,
      )
    ) {
      return;
    }

    this.setState({ loading: true });

    fetch(`${API_BASE}/api/donors/${donor.id}`, {
      method: "DELETE",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (data.status === true) {
          this.setState((prev) => ({
            donors: prev.donors.filter((d) => d.id !== donor.id),
            loading: false,
          }));
          // Show success message (optional)
          this.setState({
            message: `Donor "${donor.full_name}" deleted successfully!`,
          });
          setTimeout(() => this.setState({ message: null }), 3000);
        } else {
          throw new Error(data.message || "Failed to delete donor");
        }
      })
      .catch((err) => {
        console.error("Delete error:", err);
        this.setState({
          error: "Failed to delete donor: " + err.message,
          loading: false,
        });
      });
  };

  openDeleteModal = (donor) => {
    this.setState({
      showDeleteModal: true,
      deleteDonorData: donor,
      deleting: false,
    });
  };

  closeDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
      deleteDonorData: null,
      deleting: false,
    });
  };

  confirmDelete = () => {
    const { deleteDonorData } = this.state;
    if (!deleteDonorData) return;

    this.setState({ deleting: true });

    fetch(`${API_BASE}/api/donors/${deleteDonorData.id}`, {
      method: "DELETE",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (data.status === true) {
          this.setState((prev) => ({
            donors: prev.donors.filter((d) => d.id !== deleteDonorData.id),
            deleting: false,
            showDeleteModal: false,
            deleteDonorData: null,
          }));
          this.setState({
            message: `Donor "${deleteDonorData.full_name}" deleted successfully!`,
          });
          setTimeout(() => this.setState({ message: null }), 3000);
        } else {
          throw new Error(data.message || "Failed to delete donor");
        }
      })
      .catch((err) => {
        console.error("Delete error:", err);
        this.setState({
          error: "Failed to delete donor: " + err.message,
          deleting: false,
        });
      });
  };

  renderDeleteModal() {
    const { showDeleteModal, deleteDonorData, deleting } = this.state;
    if (!showDeleteModal || !deleteDonorData) return null;

    return (
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title">Confirm Delete</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={this.closeDeleteModal}
                disabled={deleting}
              />
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete the following donor?</p>
              <div className="bg-light p-3 rounded">
                <p className="mb-1">
                  <strong>Name:</strong> {deleteDonorData.full_name}
                </p>
                <p className="mb-1">
                  <strong>Donor ID:</strong> {deleteDonorData.donor_id}
                </p>
                <p className="mb-0">
                  <strong>Blood Group:</strong> {deleteDonorData.blood_group}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={this.closeDeleteModal}
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={this.confirmDelete}
                disabled={deleting}
              >
                {deleting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Deleting...
                  </>
                ) : (
                  "Delete Donor"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderActions(donor) {
    return (
      <div className="d-flex align-items-center gap-2 justify-content-center">
        <button
          className="btn btn-link text-primary p-0"
          title="Edit Donor"
          onClick={() => this.openEditFromTable(donor)}
        >
          <i className="bi bi-pencil-fill fs-5"></i>
        </button>

        <button
          className="btn btn-link text-danger p-0"
          title="Change Status"
          onClick={() => this.openStatusModal(donor)}
        >
          <i className="bi bi-clipboard2-check-fill fs-5"></i>
        </button>

        {donor.status === "approved" && (
          <button
            className="btn btn-link text-success p-0"
            title="Issue Donor Card"
            onClick={() => this.openCardModal(donor)}
          >
            <i className="bi bi-person-badge-fill fs-5"></i>
          </button>
        )}

        {/* Add Delete button */}
        <button
          className="btn btn-link text-danger p-0"
          title="Delete Donor"
          onClick={() => this.deleteDonor(donor)}
        >
          <i className="bi bi-trash-fill fs-5"></i>
        </button>
      </div>
    );
  }

  renderField(
    label,
    name,
    value,
    error,
    type = "text",
    props = {},
    col = "col-md-6",
  ) {
    return (
      <div className={col}>
        <label className="form-label fw-semibold">{label}</label>
        <input
          type={type}
          name={name}
          className={`form-control ${error ? "is-invalid" : ""}`}
          value={value || ""}
          onChange={this.handleInputChange}
          {...props}
        />
        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    );
  }

  render() {
    const { loading, error, viewMode } = this.state;
    const filtered = this.filterDonors();

    return (
      <div
        style={{ background: "#f4f6fb" }}
        className="pt-5 mt-4"
      >
        <div className="container ">
         
          <div className="d-flex justify-content-between align-items-start mb-4 flex-wrap gap-3 mt-4">
            <div>
              <h4 className="fw-bold mb-1" style={{ color: "#c9140e" }}>
                <i className="bi bi-people-fill me-2"></i>
                Donor Management
              </h4>
            </div>
          </div>

          {(() => {
            const { donors } = this.state;

            const stats = {
              total: donors.length,
              approved: donors.filter((d) => d.status === "approved").length,
              pending: donors.filter((d) => d.status === "pending").length,
              rejected: donors.filter((d) => d.status === "rejected").length,
            };

            const cards = [
              {
                title: "Total Donors",
                value: stats.total,
                icon: "bi-people-fill",
                color: "#2563eb",
                bg: "#eff6ff",
              },
              {
                title: "Approved",
                value: stats.approved,
                icon: "bi-check-circle-fill",
                color: "#16a34a",
                bg: "#ecfdf5",
              },
              {
                title: "Pending",
                value: stats.pending,
                icon: "bi-hourglass-split",
                color: "#f59e0b",
                bg: "#fff7ed",
              },
              {
                title: "Rejected",
                value: stats.rejected,
                icon: "bi-x-circle-fill",
                color: "#dc2626",
                bg: "#fef2f2",
              },
            ];

            return (
              <div className="row g-4 mb-4">
                {cards.map((card, index) => (
                  <div className="col-lg-3 col-md-6" key={index}>
                    <div
                      className="card border-0 shadow-sm h-100 stat-card"
                      style={{
                        borderTop: `5px solid ${card.color}`,
                        borderRadius: "16px",
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <div
                              className="text-uppercase fw-semibold mb-2"
                              style={{
                                fontSize: 13,
                                color: "#6b7280",
                                letterSpacing: 1,
                              }}
                            >
                              {card.title}
                            </div>

                            <h1
                              className="fw-bold mb-0"
                              style={{
                                fontSize: "2.4rem",
                                color: "#111827",
                              }}
                            >
                              {card.value}
                            </h1>
                          </div>

                          <div
                            style={{
                              width: 65,
                              height: 65,
                              borderRadius: "50%",
                              background: card.bg,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className={`bi ${card.icon}`}
                              style={{
                                color: card.color,
                                fontSize: "1.8rem",
                              }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            );
          })()}

          <div
            className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3"
            style={{
              background: "#fff",
              borderRadius: 14,
              padding: "18px 24px",
              boxShadow: "0 1px 3px rgba(27,27,31,0.06)",
            }}
          >
            {/* Left: Title */}
            <h5 className="fw-bold mb-0" style={{ color: "#1B1B1F" }}>
              Donor Management
            </h5>

            {/* Right: Search + Filters + Actions */}
            <div className="d-flex flex-wrap align-items-center gap-2">
              {/* Search box with icon */}
              <div
                className="d-flex align-items-center"
                style={{
                  background: "#F4F6FB",
                  borderRadius: 10,
                  padding: "8px 14px",
                  minWidth: 220,
                }}
              >
                <i
                  className="bi bi-search text-muted me-2"
                  style={{ fontSize: 14 }}
                />
                <input
                  type="text"
                  placeholder="Search patient or donor..."
                  className="border-0 bg-transparent flex-fill"
                  style={{ outline: "none", fontSize: 14 }}
                  value={this.state.patientSearch}
                  onChange={(e) =>
                    this.setState({ patientSearch: e.target.value })
                  }
                />
              </div>

              {/* Blood group dropdown */}
              <select
                className="form-select"
                style={{
                  borderRadius: 10,
                  fontSize: 14,
                  width: 140,
                  border: "1px solid #E7E0D8",
                  background: "#F4F6FB",
                }}
                value={this.state.bloodGroupFilter}
                onChange={(e) =>
                  this.setState({ bloodGroupFilter: e.target.value })
                }
              >
                <option value="">All Groups</option>
                {BLOOD_GROUPS.map((g) => (
                  <option key={g} value={g}>
                    {g}
                  </option>
                ))}
              </select>

              {/* Status filter kept, restyled */}
              <select
                className="form-select"
                style={{
                  borderRadius: 10,
                  fontSize: 14,
                  width: 140,
                  border: "1px solid #E7E0D8",
                  background: "#F4F6FB",
                }}
                value={this.state.statusFilter}
                onChange={(e) =>
                  this.setState({ statusFilter: e.target.value })
                }
              >
                <option value="all">All Status</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>

              {/* Action buttons */}
              <button
                className="btn btn-outline-danger"
                style={{ borderRadius: 10, fontSize: 14 }}
                onClick={this.openImportModal}
              >
                <i className="bi bi-file-earmark-excel me-2"></i>
                Import
              </button>

              <button
                className="btn btn-danger"
                style={{ borderRadius: 10, fontSize: 14 }}
                onClick={() =>
                  this.setState({
                    formMode: "add",
                    formErrors: {},
                    form: { ...EMPTY_FORM },
                    showFormModal: true,
                  })
                }
              >
                <i className="bi bi-plus-circle me-2"></i>
                Add Donor
              </button>
            </div>
          </div>

          {/* Error Message */}
          {error && (
            <div
              className="alert alert-danger alert-dismissible fade show"
              role="alert"
            >
              <i className="bi bi-exclamation-triangle-fill me-2"></i>
              {error}
              <button
                type="button"
                className="btn-close"
                onClick={() => this.setState({ error: null })}
              ></button>
            </div>
          )}
          {this.state.showBulkActions && (
            <div className="alert alert-secondary d-flex justify-content-between align-items-center mb-3">
              <div>
                <strong>{this.state.selectedRows.length}</strong> donor(s)
                selected
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-success"
                  onClick={() =>
                    this.setState(
                      { bulkSelectedStatus: "approved" },
                      this.openBulkStatusModal,
                    )
                  }
                >
                  <i className="bi bi-check-circle me-1"></i> Approve/Reject
                </button>

                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() =>
                    this.setState({ selectedRows: [], showBulkActions: false })
                  }
                >
                  Clear Selection
                </button>
              </div>
            </div>
          )}
          {/* Loading State */}
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2 text-muted">Loading donors...</p>
            </div>
          ) : filtered.length === 0 ? (
            <div className="card border-0 shadow-sm">
              <div className="card-body text-center py-5">
                <i className="bi bi-inbox display-1 text-muted"></i>
                <h5 className="mt-3">No donors found</h5>
                <p className="text-muted">
                  Try adjusting your search or filters
                </p>
                <button
                  className="btn btn-danger"
                  onClick={() =>
                    this.setState({ search: "", statusFilter: "all" })
                  }
                >
                  Clear Filters
                </button>
              </div>
            </div>
          ) : (
            <div className="card border-0 shadow-sm">
              <div className="rounded-4" style={{ overflowX: "auto" }}>
                {this.renderDonorsTable(filtered)}
              </div>
            </div>
          )}

          {this.renderDonorDetailsModal()}
          {this.renderFormModal()}
          {this.renderCardModal()}
          {this.renderStatusModal()}
          {this.renderImportModal()}
          {this.renderBulkStatusModal()}
          {this.renderDeleteModal()}
        </div>
      </div>
    );
  }
}

export default DonorList;